export const ReportLOADING = "report/Loading";
export const ReportERROR = "report/Error";
export const ReportSUCCESS = "report/Success";
